import { render, staticRenderFns } from "./BatchesApprove.vue?vue&type=template&id=f04eb288&"
import script from "./BatchesApprove.vue?vue&type=script&lang=js&"
export * from "./BatchesApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f04eb288')) {
      api.createRecord('f04eb288', component.options)
    } else {
      api.reload('f04eb288', component.options)
    }
    module.hot.accept("./BatchesApprove.vue?vue&type=template&id=f04eb288&", function () {
      api.rerender('f04eb288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchesApprove.vue"
export default component.exports